(function () {
  var modals = {};
  var activeType = null;
  var lastFocus = null;

  var state = {
    insoles: { step: "customer_type", history: [], answers: {} },
    footwear: { step: "customer", history: [], answers: {} }
  };

  var insoleProducts = {
    catalyst: {
      title: "Biopods® Catalyst Dynamic Sensory Insoles",
      subtitle: "Core dynamic sensory experience",
      text: "Best starting point for most new users and for flexible everyday footwear. Catalyst provides the shared tactile foundation of the new Biopods and Barefoot Science platform.",
      url: "/products/biopods-catalyst-dynamic-sensory-insoles"
    },
    dynamis: {
      title: "Barefoot Science® Dynamis Sensory Insoles",
      subtitle: "Personalized sensory experience",
      text: "Best for familiar adjustability, a more noticeable starting stimulus, or one pair that may move between different footwear environments.",
      url: "/products/barefoot-science-dynamis-insoles"
    },
    resonance: {
      title: "Biopods® Resonance Tunable Harmonic Insoles",
      subtitle: "Tactile foundation plus harmonic resonance",
      text: "Best for those who want the Catalyst tactile foundation with the added resonance element and a more holistic sensory experience.",
      url: "/products/biopods-resonance-insoles"
    },
    nextgen: {
      title: "Next Generation Stimsoles® Insoles",
      subtitle: "Previous-generation Biopods dynamic stimulus",
      text: "Best for those who want the familiar previous-generation Biopods experience with full-length and 3/4-length options.",
      url: "/products/next-generation-stimsoles®-insoles"
    },
    original_all_purpose: {
      title: "Original All Purpose Stimsoles® Insoles",
      subtitle: "Original Biopods everyday stimulus platform",
      text: "Best for those seeking the familiar original Biopods feel, with VRT stimulus levels for different footwear and everyday activity needs.",
      url: "/products/original-all-purpose-stimsoles-insoles"
    },
    original_performance: {
      title: "Original Performance Stimsoles® Insoles",
      subtitle: "Original Biopods active-use stimulus platform",
      text: "Best for those seeking the familiar original Biopods experience for active or performance use.",
      url: "/products/original-performance-stimsoles-insoles"
    },
    bfs4: {
      title: "Barefoot Science® 4 Step System",
      subtitle: "Four-step interchangeable-insert system",
      text: "Best for those who want a familiar lower-level Barefoot Science progression with adjustable stimulus.",
      url: "/products/barefoot-science®-4-step-system"
    },
    bfs5: {
      title: "Barefoot Science® 5 Step System",
      subtitle: "Five-step interchangeable-insert system",
      text: "Best for those who want a familiar moderate Barefoot Science progression with adjustable stimulus.",
      url: "/products/barefoot-science®-step-system"
    },
    bfs6: {
      title: "Barefoot Science® 6 Step System",
      subtitle: "Six-step interchangeable-insert system",
      text: "Best for experienced Barefoot Science users who want a familiar higher-level adjustable progression.",
      url: "/products/barefoot-science-6-step-system"
    },
    bfs7: {
      title: "Barefoot Science® 7 Step System",
      subtitle: "Seven-step interchangeable-insert system",
      text: "Best for experienced Barefoot Science users who want the broadest familiar legacy progression.",
      url: "/products/barefoot-science®-7-step-system"
    }
  };

  var insoleInventory = [];
  var footwearVariants = [];

  var questions = {
    insoles: {
      customer_type: {
        progress: 12,
        title: "Are you a current Barefoot Science or Biopods user?",
        type: "single",
        options: [
          ["barefoot_science", "I am a Barefoot Science user"],
          ["biopods", "I am a Biopods user"],
          ["first_time", "I am a first-time user"]
        ]
      },
      bfs_direction: {
        progress: 25,
        title: "Which Barefoot Science direction feels right?",
        type: "single",
        options: [
          ["familiar_bfs", "I want the same familiar Barefoot Science feel"],
          ["newest_bfs", "I want the newest Barefoot Science tactile technology"],
          ["adjustable", "I want adjustable / personalized stimulus"]
        ]
      },
      bfs_level: {
        progress: 34,
        title: "What Barefoot Science level are we used to?",
        type: "single",
        options: [
          ["levels_1_5", "Levels 1-5"],
          ["levels_6_7", "Levels 6-7"]
        ]
      },
      biopods_direction: {
        progress: 25,
        title: "Which Biopods direction feels right?",
        type: "single",
        options: [
          ["familiar_biopods", "I want the same familiar Biopods feel"],
          ["newest_core", "I want the newest core technology"],
          ["adjustable", "I want adjustable / personalized stimulus"],
          ["resonance", "I want the resonance / holistic wellness experience"]
        ]
      },
      first_time_goal: {
        progress: 25,
        title: "What are you seeking?",
        type: "single",
        options: [
          ["pain", "Relief from foot, hip, or back discomfort"],
          ["performance", "Performance enhancement / injury prevention"],
          ["healthy_alternative", "A healthy alternative to conventional support and cushioning"]
        ]
      },
      foot_type: {
        progress: 48,
        title: "What best describes your feet right now?",
        help: "This is only a starting point. Functional capability can change as the body adapts to better sensory information.",
        type: "single",
        options: [
          ["rigid_flat", "Rigid flat foot or very limited arch movement"],
          ["regular_flexible", "Regular arch / flexible foot / arch lowers when standing"],
          ["high_rigid", "High arch / rigid or less adaptable foot"],
          ["not_sure", "Not sure"]
        ]
      },
      shoes: {
        progress: 66,
        title: "What shoes will you use them in?",
        help: "Select all that apply, especially if one pair will move from shoe to shoe.",
        type: "multi",
        options: [
          ["flexible_removable", "Flexible shoes with removable insoles"],
          ["moderate", "Moderately supportive or cushioned shoes"],
          ["restrictive", "Tight, stiff, shallow, or heavily cushioned shoes"],
          ["no_removable", "Shoes without removable insoles"],
          ["move_between", "I plan to use one pair of insoles in different shoes"]
        ]
      },
      preference: {
        progress: 80,
        title: "Which experience sounds most right?",
        type: "single",
        options: [
          ["first_time_best", "I want whatever is best for experiencing sensory insoles for the first time."],
          ["simple", "I want the core dynamic sensory experience"],
          ["personalized", "I want an adjustable / personalized sensory experience"],
          ["resonance", "I want a resonance / holistic experience"],
          ["familiar", "I want something that is closest to my current familiar feel"]
        ]
      },
      insole_size: {
        progress: 94,
        title: "What shoe size are these insoles for?",
        type: "insole_size",
        options: [
          ["child", "Children's"],
          ["man", "Men's"],
          ["woman", "Women's"]
        ]
      }
    },
    footwear: {
      customer: {
        progress: 25,
        title: "Who are the shoes for?",
        type: "single",
        options: [
          ["child", "Child"],
          ["woman", "Woman"],
          ["man", "Man"]
        ]
      },
      size: {
        progress: 55,
        title: "Select size",
        type: "single",
        options: []
      },
      width: {
        progress: 82,
        title: "What is your/their foot width?",
        type: "single",
        options: [
          ["narrow", "Narrow"],
          ["standard", "Standard"],
          ["wide", "Wide"]
        ]
      }
    }
  };

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function includes(list, value) {
    return Array.isArray(list) && list.indexOf(value) !== -1;
  }

  function normalise(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9.]+/g, " ")
      .trim();
  }

  function getNamedOption(item, names) {
    var optionNames = Array.isArray(item.optionNames) ? item.optionNames : [];
    var optionValues = Array.isArray(item.optionValues) ? item.optionValues : [];
    var wanted = Array.isArray(names) ? names : [names];
    var index = optionNames.findIndex(function (name) {
      var normalisedName = normalise(name);
      return wanted.some(function (candidate) {
        return normalisedName.indexOf(normalise(candidate)) !== -1;
      });
    });
    return index > -1 ? String(optionValues[index] || "").trim() : "";
  }

  function detectInsoleModelKey(item) {
    var handle = normalise(item.productHandle);
    var title = normalise(item.productTitle);
    if (handle.indexOf("catalyst") !== -1) return "catalyst";
    if (handle.indexOf("dynamis") !== -1) return "dynamis";
    if (handle.indexOf("resonance") !== -1) return "resonance";
    if (handle.indexOf("next generation") !== -1) return "nextgen";
    if (handle.indexOf("original all purpose") !== -1) return "original_all_purpose";
    if (handle.indexOf("original performance") !== -1) return "original_performance";
    if (title.indexOf("7 step system") !== -1) return "bfs7";
    if (title.indexOf("6 step system") !== -1) return "bfs6";
    if (title.indexOf("5 step system") !== -1) return "bfs5";
    if (title.indexOf("4 step system") !== -1) return "bfs4";
    return "";
  }

  function detectInsoleAudience(item) {
    var sizeOption = normalise(getNamedOption(item, "size"));
    if (/\b(youth|child|children|kids?)\b/.test(sizeOption)) return "child";
    if (/\b(woman|women|womens|female)\b/.test(sizeOption)) return "woman";
    if (/\b(man|men|mens|male)\b/.test(sizeOption)) return "man";
    return "";
  }

  function detectInsoleSizeRange(item) {
    var sizeOption = getNamedOption(item, "size");
    var numbers = String(sizeOption || "").match(/[0-9]+(?:\.[0-9]+)?/g) || [];
    if (!numbers.length) return { min: NaN, max: NaN, label: sizeOption };
    var start = Number(numbers[0]);
    var end = Number(numbers.length > 1 ? numbers[numbers.length - 1] : numbers[0]);
    return {
      start: start,
      end: end,
      min: Math.min(start, end),
      max: Math.max(start, end),
      label: sizeOption
    };
  }

  function expandInsoleSizeRange(range, audience) {
    var sizes = [];

    function addRange(start, end) {
      for (var size = start; size <= end + 0.001; size += 0.5) {
        var displayed = displayShoeSize(size);
        if (sizes.indexOf(displayed) === -1) sizes.push(displayed);
      }
    }

    if (audience === "child" && range.start >= 12 && range.end <= 1.5) {
      addRange(range.start, 13.5);
      addRange(1, range.end);
    } else {
      addRange(range.min, range.max);
    }

    return sizes;
  }

  function readInsoleInventory() {
    var dataElement = document.getElementById("biopods-insole-inventory");
    if (!dataElement) return [];

    try {
      var records = JSON.parse(dataElement.textContent);
      return (Array.isArray(records) ? records : []).map(function (item) {
        var range = detectInsoleSizeRange(item);
        var audience = detectInsoleAudience(item);
        item.modelKey = detectInsoleModelKey(item);
        item.audience = audience;
        item.sizeMin = range.min;
        item.sizeMax = range.max;
        item.sizeRangeLabel = range.label;
        item.shoeSizes = expandInsoleSizeRange(range, audience);
        item.version = getNamedOption(item, ["version", "stimulus level"]) || "Full length";
        return item;
      }).filter(function (item) {
        return item.modelKey && item.audience && item.shoeSizes.length > 0;
      });
    } catch (error) {
      if (window.console && console.error) console.error("Biopods insole inventory could not be loaded.", error);
      return [];
    }
  }

  function displayShoeSize(value) {
    var number = Number(value);
    return Number.isInteger(number) ? String(number) : String(number).replace(/0+$/, "").replace(/\.$/, "");
  }

  function getInsoleShoeSizes(audience) {
    var sizes = [];
    insoleInventory.filter(function (item) {
      return item.audience === audience;
    }).forEach(function (item) {
      item.shoeSizes.forEach(function (size) {
        if (sizes.indexOf(size) === -1) sizes.push(size);
      });
    });

    if (!sizes.length) {
      var fallbackSizes = {
        child: ["12", "12.5", "13", "13.5", "1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5"],
        woman: ["4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5"],
        man: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "14", "14.5", "15", "15.5", "16", "16.5", "17", "17.5"]
      };
      sizes = fallbackSizes[audience] || [];
    }

    return sizes.sort(function (a, b) {
      if (audience === "child") {
        var aValue = Number(a) >= 12 ? Number(a) - 12 : Number(a) + 2;
        var bValue = Number(b) >= 12 ? Number(b) - 12 : Number(b) + 2;
        return aValue - bValue;
      }
      return Number(a) - Number(b);
    });
  }

  function matchingInsoleInventory(audience, shoeSize) {
    var displayedSize = displayShoeSize(shoeSize);
    return insoleInventory.filter(function (item) {
      return item.inStock === true &&
        item.audience === audience &&
        item.shoeSizes.indexOf(displayedSize) !== -1;
    });
  }

  function detectFootwearAudience(item) {
    var sizeOption = normalise(getNamedOption(item, "size"));
    var haystack = sizeOption || normalise(item.variantTitle);
    if (/\b(child|children|kid|kids|youth)\b/.test(haystack)) return "child";
    if (/\b(woman|women|womens|female|ladies)\b/.test(haystack)) return "woman";
    if (/\b(man|men|mens|male)\b/.test(haystack)) return "man";
    return "";
  }

  function detectFootwearSize(item) {
    var size = getNamedOption(item, "size");
    if (!size) size = String(item.variantTitle || "").split("/").pop();
    return String(size || "")
      .replace(/^\s*(?:child(?:ren)?|kids?|youth|women(?:['’]?s)?|woman|men(?:['’]?s)?|man)\s*:\s*/i, "")
      .trim();
  }

  function detectFootwearWidth(item) {
    var namedWidth = normalise(getNamedOption(item, "width"));
    var haystack = normalise([
      namedWidth,
      item.productTitle,
      item.productHandle,
      item.productType,
      Array.isArray(item.productTags) ? item.productTags.join(" ") : ""
    ].join(" "));

    if (/\bnarrow\b/.test(haystack)) return "narrow";
    if (/\bwide\b/.test(haystack) || /\b(2e|3e|4e)\b/.test(namedWidth)) return "wide";
    return "standard";
  }

  function detectFootwearModel(item) {
    var source = normalise(item.sourceCollection);
    var title = normalise(item.productTitle);
    if (source.indexOf("urban flex") !== -1 || title.indexOf("urban flex") !== -1) return "Urban Flex Sneakers";
    if (source.indexOf("classic") !== -1 || title.indexOf("classic") !== -1) return "Classic Sneakers";
    if (source.indexOf("urban") !== -1 || title.indexOf("urban") !== -1) return "Urban Sneakers";
    return String(item.productType || "Biopods Footwear");
  }

  function detectFootwearColor(item) {
    var color = getNamedOption(item, ["color", "colour"]);
    if (color) return color;
    var titleParts = String(item.productTitle || "").split(" - ");
    return titleParts.length > 1 ? titleParts.slice(1).join(" - ") : "";
  }

  function sizeSortValue(size) {
    var match = String(size || "").match(/([0-9]+(?:\.[0-9]+)?)/);
    return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
  }

  function readFootwearVariants() {
    var dataElement = document.getElementById("biopods-footwear-variants");
    if (!dataElement) return [];

    try {
      var records = JSON.parse(dataElement.textContent);
      var seen = {};
      return (Array.isArray(records) ? records : []).map(function (item) {
        item.audience = detectFootwearAudience(item);
        item.size = detectFootwearSize(item);
        item.width = detectFootwearWidth(item);
        item.model = detectFootwearModel(item);
        item.color = detectFootwearColor(item);
        return item;
      }).filter(function (item) {
        var key = String(item.variantId || "");
        if (!key || !item.audience || !item.size || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    } catch (error) {
      if (window.console && console.error) console.error("Biopods footwear inventory could not be loaded.", error);
      return [];
    }
  }

  function matchingFootwearVariants(filters) {
    filters = filters || {};
    return footwearVariants.filter(function (item) {
      if (filters.audience && item.audience !== filters.audience) return false;
      if (filters.size && normalise(item.size) !== normalise(filters.size)) return false;
      if (filters.width && item.width !== filters.width) return false;
      return true;
    });
  }

  function normaliseType(value) {
    if (value === "insole") return "insoles";
    if (value === "shoe" || value === "shoes") return "footwear";
    return value;
  }

  function setProgress(type, amount) {
    var progress = modals[type] && modals[type].progress;
    if (progress) progress.style.width = amount + "%";
  }

  function getModal(type) {
    return modals[type] && modals[type].modal;
  }

  function resetQuiz(type) {
    state[type].history = [];
    state[type].answers = {};
    state[type].step = type === "footwear" ? "customer" : "customer_type";
  }

  function openQuiz(type) {
    type = normaliseType(type);
    var modal = getModal(type);
    if (!modal) return;

    lastFocus = document.activeElement;
    activeType = type;
    resetQuiz(type);
    render(type);
    modal.hidden = false;
    document.documentElement.classList.add("biopods-finder-open");
    document.body.classList.add("biopods-finder-open");

    window.setTimeout(function () {
      var dialog = modal.querySelector(".biopods-finder-dialog");
      if (dialog) dialog.focus();
    }, 0);
  }

  function closeQuiz() {
    if (!activeType) return;
    var modal = getModal(activeType);
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove("biopods-finder-open");
    document.body.classList.remove("biopods-finder-open");
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
    activeType = null;
    lastFocus = null;
  }

  function getStep(type) {
    return questions[type][state[type].step];
  }

  function getStepOptions(type, stepId, step) {
    if (type === "insoles" && stepId === "preference") {
      return (step.options || []).filter(function (option) {
        if (state.insoles.answers.customer_type === "first_time") return option[0] !== "familiar";
        return option[0] !== "first_time_best";
      });
    }
    if (type === "footwear" && stepId === "size") {
      var customer = state.footwear.answers.customer || "";
      var sizes = [];
      matchingFootwearVariants({ audience: customer }).forEach(function (item) {
        if (sizes.indexOf(item.size) === -1) sizes.push(item.size);
      });
      sizes.sort(function (a, b) {
        return sizeSortValue(a) - sizeSortValue(b) || String(a).localeCompare(String(b));
      });
      return sizes.map(function (size) {
        return [size, size];
      });
    }
    if (type === "footwear" && stepId === "width") {
      var answers = state.footwear.answers;
      var widthRanges = answers.customer === "woman" ? {
        narrow: "A to AAA",
        standard: "B to C",
        wide: "D to E"
      } : {
        narrow: "B to C",
        standard: "D to E",
        wide: "EE to 4E"
      };
      return (step.options || []).map(function (option) {
        var hasStock = matchingFootwearVariants({
          audience: answers.customer,
          size: answers.size,
          width: option[0]
        }).length > 0;
        var label = option[1] + " - " + widthRanges[option[0]];
        return [option[0], label + (hasStock ? "" : " — no stock in this size"), !hasStock];
      });
    }
    return step.options || [];
  }

  function nextStep(type, stepId, value) {
    if (type === "footwear") {
      if (stepId === "customer") return "size";
      if (stepId === "size") return "width";
      if (stepId === "width") return "results";
      return "results";
    }

    if (stepId === "customer_type") {
      if (value === "barefoot_science") return "bfs_direction";
      if (value === "biopods") return "biopods_direction";
      return "first_time_goal";
    }

    if (stepId === "bfs_direction") {
      return value === "familiar_bfs" ? "bfs_level" : "foot_type";
    }

    if (stepId === "bfs_level" || stepId === "biopods_direction" || stepId === "first_time_goal") return "foot_type";
    if (stepId === "foot_type") return "shoes";
    if (stepId === "shoes") return "preference";
    if (stepId === "preference") return "insole_size";
    return "results";
  }

  function goTo(type, next) {
    if (next === "results") {
      state[type].history.push(state[type].step);
      state[type].step = "results";
      renderResults(type);
      return;
    }
    state[type].history.push(state[type].step);
    state[type].step = next;
    render(type);
  }

  function goBack(type) {
    var previous = state[type].history.pop();
    if (!previous) return;
    state[type].step = previous;
    render(type);
  }

  function renderActions(type, showContinue) {
    var hasHistory = state[type].history.length > 0;
    var html = '<div class="biopods-finder-actions">';
    if (hasHistory) {
      html += '<button type="button" class="biopods-finder-secondary" data-biopods-finder-back>Back</button>';
    }
    if (showContinue) {
      html += '<button type="button" class="biopods-finder-primary" data-biopods-finder-continue>Continue</button>';
    }
    html += "</div>";
    return html;
  }

  function renderInsoleSizeStep() {
    var step = questions.insoles.insole_size;
    var answers = state.insoles.answers;
    var selectedAudience = answers.insole_size_audience || "";
    var selectedSize = answers.insole_size || "";
    var html = '<div class="biopods-finder-step biopods-finder-size-step">';
    html += '<h3>' + escapeHtml(step.title) + "</h3>";
    html += '<div class="biopods-finder-options biopods-finder-size-audiences">';

    step.options.forEach(function (option) {
      var selected = selectedAudience === option[0];
      html += '<button type="button" class="biopods-finder-option' + (selected ? " is-selected" : "") + '" data-biopods-insole-audience="' + escapeHtml(option[0]) + '">';
      html += '<span class="biopods-finder-radio" aria-hidden="true"></span>';
      html += '<span>' + escapeHtml(option[1]) + "</span>";
      html += "</button>";
    });

    html += "</div>";
    if (selectedAudience) {
      var labelMap = { child: "Children's", man: "Men's", woman: "Women's" };
      var sizes = getInsoleShoeSizes(selectedAudience);
      html += '<label class="biopods-finder-size-select">';
      html += '<span>Select ' + escapeHtml(labelMap[selectedAudience]) + " US shoe size</span>";
      html += '<select data-biopods-insole-size>';
      html += '<option value="">Select size</option>';
      sizes.forEach(function (size) {
        html += '<option value="' + escapeHtml(size) + '"' + (selectedSize === size ? " selected" : "") + ">US " + escapeHtml(size) + "</option>";
      });
      html += "</select></label>";
    } else {
      html += '<p class="biopods-finder-help">Choose Children\'s, Men\'s, or Women\'s to see the shoe-size list.</p>';
    }
    html += renderActions("insoles", false);
    html += "</div>";
    return html;
  }

  function render(type) {
    var stepId = state[type].step;
    var step = getStep(type);
    var body = modals[type].body;
    if (!step || !body) return;

    setProgress(type, step.progress || 0);

    if (type === "insoles" && stepId === "insole_size") {
      body.innerHTML = renderInsoleSizeStep();
      return;
    }

    var answer = state[type].answers[stepId];
    var options = getStepOptions(type, stepId, step);
    var html = '<div class="biopods-finder-step">';
    html += '<h3>' + escapeHtml(step.title) + "</h3>";
    if (step.help) html += '<p class="biopods-finder-help">' + escapeHtml(step.help) + "</p>";
    html += '<div class="biopods-finder-options">';

    options.forEach(function (option) {
      var value = option[0];
      var label = option[1];
      var disabled = option[2] === true;
      var selected = step.type === "multi" ? includes(answer, value) : answer === value;
      html += '<button type="button" class="biopods-finder-option' + (selected ? " is-selected" : "") + '" ';
      html += step.type === "multi" ? 'data-biopods-finder-multi="' : 'data-biopods-finder-choice="';
      html += escapeHtml(value) + '"' + (disabled ? " disabled" : "") + ">";
      html += '<span class="biopods-finder-radio" aria-hidden="true"></span>';
      html += '<span>' + escapeHtml(label) + "</span>";
      html += "</button>";
    });

    html += "</div>";
    if (type === "footwear" && options.length === 0) {
      html += '<div class="biopods-finder-empty"><strong>No in-stock sizes are available for this selection right now.</strong><br>Please try another category or check back soon.</div>';
    }
    html += renderActions(type, step.type === "multi");
    html += "</div>";
    body.innerHTML = html;

    var continueButton = body.querySelector("[data-biopods-finder-continue]");
    if (continueButton && (!Array.isArray(answer) || answer.length === 0)) {
      continueButton.disabled = true;
    }
  }

  function selectChoice(type, value) {
    var stepId = state[type].step;
    if (type === "insoles" && stepId === "customer_type") {
      state.insoles.answers = {};
    }
    if (type === "footwear" && stepId === "customer") {
      delete state.footwear.answers.size;
      delete state.footwear.answers.width;
    }
    if (type === "footwear" && stepId === "size") {
      delete state.footwear.answers.width;
    }
    state[type].answers[stepId] = value;
    goTo(type, nextStep(type, stepId, value));
  }

  function toggleMulti(type, value) {
    var stepId = state[type].step;
    var selected = state[type].answers[stepId];
    if (!Array.isArray(selected)) selected = [];
    if (includes(selected, value)) {
      selected = selected.filter(function (item) {
        return item !== value;
      });
    } else {
      selected.push(value);
    }
    state[type].answers[stepId] = selected;
    render(type);
  }

  function rankInsoleModels() {
    var answers = state.insoles.answers;
    var shoes = answers.shoes || [];
    var modelOrder = [
      "catalyst", "dynamis", "resonance", "nextgen", "original_all_purpose",
      "original_performance", "bfs4", "bfs5", "bfs6", "bfs7"
    ];
    var originalOrder = modelOrder.slice();
    var scores = {};
    modelOrder.forEach(function (modelKey) { scores[modelKey] = 0; });

    function score(modelKeys, amount) {
      modelKeys.forEach(function (modelKey) {
        scores[modelKey] += amount;
      });
    }

    function scoreRanked(modelKeys, amount) {
      modelKeys.forEach(function (modelKey, index) {
        scores[modelKey] += Math.max(amount - (index * 5), 0);
      });
    }

    function barefootScienceLegacyOrder() {
      if (answers.bfs_level === "levels_6_7" || answers.foot_type === "rigid_flat") return ["bfs7", "bfs6", "bfs5", "bfs4"];
      if (answers.foot_type === "high_rigid") return ["bfs4", "bfs5", "bfs6", "bfs7"];
      return ["bfs5", "bfs4", "bfs6", "bfs7"];
    }

    function biopodsLegacyOrder() {
      if (includes(shoes, "no_removable")) return ["original_all_purpose", "nextgen", "original_performance"];
      if (answers.first_time_goal === "performance") return ["original_performance", "nextgen", "original_all_purpose"];
      return ["nextgen", "original_all_purpose", "original_performance"];
    }

    var bfsLegacy = barefootScienceLegacyOrder();
    var biopodsLegacy = biopodsLegacyOrder();

    score(["catalyst"], 10);
    score(["dynamis"], 8);
    score(["nextgen"], 3);

    if (answers.customer_type === "barefoot_science") {
      scoreRanked(bfsLegacy, 10);
      if (answers.bfs_direction === "familiar_bfs") {
        scoreRanked(bfsLegacy.slice(0, 2), 100);
        score(["dynamis"], 20);
      } else if (answers.bfs_direction === "newest_bfs" || answers.bfs_direction === "adjustable") {
        score(["dynamis"], 110);
        scoreRanked(bfsLegacy.slice(0, 2), 20);
      }
    } else if (answers.customer_type === "biopods") {
      scoreRanked(biopodsLegacy, 10);
      if (answers.biopods_direction === "familiar_biopods") {
        scoreRanked(biopodsLegacy, 100);
        score(["catalyst"], 20);
      } else if (answers.biopods_direction === "newest_core") {
        score(["catalyst"], 110);
        score(["nextgen"], 20);
      } else if (answers.biopods_direction === "adjustable") {
        score(["dynamis"], 110);
        score(bfsLegacy.slice(0, 2), 15);
      } else if (answers.biopods_direction === "resonance") {
        score(["resonance"], 120);
        score(["catalyst"], 20);
      }
    } else {
      score(["catalyst"], 20);
      score(["dynamis"], 15);
      if (answers.first_time_goal === "pain") {
        score(["dynamis"], 30);
        score(["catalyst"], 25);
        scoreRanked(bfsLegacy.slice(0, 2), 15);
      } else if (answers.first_time_goal === "performance") {
        score(["original_performance"], 35);
        score(["catalyst"], 25);
        score(["nextgen"], 20);
      } else if (answers.first_time_goal === "healthy_alternative") {
        score(["catalyst"], 35);
        score(["nextgen"], 15);
      }
    }

    if (answers.preference === "first_time_best") {
      score(["catalyst"], 80);
      score(["dynamis"], 35);
      score(["nextgen"], 15);
    } else if (answers.preference === "simple") {
      score(["catalyst"], 100);
      score(["nextgen"], 25);
    } else if (answers.preference === "personalized") {
      score(["dynamis"], 100);
      scoreRanked(bfsLegacy, 20);
    } else if (answers.preference === "resonance") {
      score(["resonance"], 130);
      score(["catalyst"], 25);
    } else if (answers.preference === "familiar") {
      if (answers.customer_type === "barefoot_science") {
        scoreRanked(bfsLegacy.slice(0, 2), 130);
        score(["dynamis"], 20);
      } else if (answers.customer_type === "biopods") {
        scoreRanked(biopodsLegacy, 130);
        score(["catalyst"], 20);
      }
    }

    if (answers.foot_type === "rigid_flat") {
      score(["dynamis", "bfs7", "bfs6"], 25);
    } else if (answers.foot_type === "high_rigid") {
      score(["dynamis", "bfs4", "bfs5"], 25);
    } else if (answers.foot_type === "regular_flexible") {
      score(["catalyst"], 15);
      score(["nextgen"], 10);
    }

    if (includes(shoes, "no_removable")) {
      score(["original_all_purpose"], 30);
      score(["dynamis", "catalyst", "nextgen", "bfs4", "bfs5", "bfs6", "bfs7"], 20);
      score(["resonance"], -100);
    }
    if (includes(shoes, "restrictive")) {
      score(["dynamis", "bfs4", "bfs5"], 25);
    }
    if (includes(shoes, "flexible_removable")) {
      score(["catalyst"], 20);
      score(["resonance", "nextgen", "original_performance"], 10);
    }
    if (includes(shoes, "moderate")) {
      score(["dynamis"], 15);
      score(["catalyst"], 10);
    }
    if (includes(shoes, "move_between")) {
      score(["dynamis"], 25);
      score(["nextgen"], 15);
    }

    return modelOrder.sort(function (a, b) {
      return scores[b] - scores[a] || originalOrder.indexOf(a) - originalOrder.indexOf(b);
    });
  }

  function chooseInsoleProduct() {
    return rankInsoleModels()[0] || "catalyst";
  }

  function displayInsoleVersion(value) {
    var normalised = normalise(value);
    if (normalised.indexOf("3 4") !== -1) return "3/4 length";
    if (normalised.indexOf("full") !== -1) return "Full length";
    return String(value || "");
  }

  function getInStockInsoleGroups() {
    var answers = state.insoles.answers;
    var matching = matchingInsoleInventory(answers.insole_size_audience, answers.insole_size);
    var groups = {};

    matching.forEach(function (item) {
      if (!groups[item.modelKey]) {
        groups[item.modelKey] = {
          modelKey: item.modelKey,
          productTitle: item.productTitle,
          productUrl: item.productUrl,
          image: item.image,
          versions: [],
          prices: [],
          lowestPriceAmount: Number.MAX_SAFE_INTEGER,
          lowestPrice: item.price
        };
      }
      var group = groups[item.modelKey];
      var version = displayInsoleVersion(item.version);
      if (group.versions.indexOf(version) === -1) group.versions.push(version);
      if (group.prices.indexOf(item.price) === -1) group.prices.push(item.price);
      var priceAmount = Number(item.priceAmount);
      if (!isNaN(priceAmount) && priceAmount < group.lowestPriceAmount) {
        group.lowestPriceAmount = priceAmount;
        group.lowestPrice = item.price;
      }
    });

    return groups;
  }

  function renderInsoleCard(group, label, audienceLabel, shoeSize) {
    var product = insoleProducts[group.modelKey] || {};
    var productUrl = group.productUrl || product.url || "#";
    var imageAlt = [group.productTitle || product.title, audienceLabel + " US " + shoeSize].filter(Boolean).join(" — ");
    var html = '<article class="biopods-finder-card biopods-finder-insole-card">';
    if (label) html += '<p class="biopods-finder-card-label">' + escapeHtml(label) + "</p>";
    if (group.image) {
      html += '<a class="biopods-finder-card-image" href="' + escapeHtml(productUrl) + '">';
      html += '<img src="' + escapeHtml(group.image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" width="720" height="450">';
      html += "</a>";
    }
    html += '<div class="biopods-finder-card-content">';
    html += "<h4>" + escapeHtml(group.productTitle || product.title || "Insole model") + "</h4>";
    if (product.subtitle) html += '<p class="biopods-finder-card-subtitle">' + escapeHtml(product.subtitle) + "</p>";
    if (product.text) html += "<p>" + escapeHtml(product.text) + "</p>";
    html += '<dl class="biopods-finder-variant-details">';
    html += "<div><dt>Size</dt><dd>" + escapeHtml(audienceLabel + " US " + shoeSize) + "</dd></div>";
    html += "<div><dt>Available</dt><dd>" + escapeHtml(group.versions.join(" and ")) + "</dd></div>";
    html += "</dl>";
    html += '<p class="biopods-finder-price"><strong>' + (group.prices.length > 1 ? "From " : "") + escapeHtml(group.lowestPrice) + "</strong></p>";
    html += '<a class="biopods-finder-card-link biopods-finder-insole-link" href="' + escapeHtml(productUrl) + '">View Product</a>';
    html += "</div></article>";
    return html;
  }

  function renderInsoleResults() {
    var answers = state.insoles.answers;
    var rankedModels = rankInsoleModels();
    var primary = rankedModels[0] || chooseInsoleProduct();
    var groups = getInStockInsoleGroups();
    var availableGroups = rankedModels.filter(function (modelKey, index) {
      return rankedModels.indexOf(modelKey) === index && groups[modelKey];
    }).map(function (modelKey) {
      return groups[modelKey];
    }).slice(0, 4);
    var audienceLabels = { child: "Children's", man: "Men's", woman: "Women's" };
    var audienceLabel = audienceLabels[answers.insole_size_audience] || "Selected";
    var html = '<div class="biopods-finder-results">';
    html += "<h3>In-stock insole recommendations: " + escapeHtml(audienceLabel + " US " + (answers.insole_size || "") + ".") + "</h3>";
    html += '<p class="biopods-finder-help">The models below suit the selected purpose and have an in-stock option covering this shoe size. Choose the available version or stimulus level on the product page.</p>';

    if (availableGroups.length) {
      html += '<div class="biopods-finder-card-grid biopods-finder-insole-grid">';
      availableGroups.forEach(function (group, index) {
        var label = group.modelKey === primary ? "Primary recommendation" : (index === 0 ? "Best available match" : "Also consider");
        html += renderInsoleCard(group, label, audienceLabel, answers.insole_size);
      });
      html += "</div>";
    } else {
      html += '<div class="biopods-finder-empty"><strong>No recommended insole models are currently in stock for this shoe size.</strong><br>Please go back to verify the size or check back soon.</div>';
    }

    html += renderResultActions();
    html += "</div>";
    return html;
  }

  function renderFootwearResults() {
    var answers = state.footwear.answers;
    var results = matchingFootwearVariants({
      audience: answers.customer,
      size: answers.size,
      width: answers.width
    }).sort(function (a, b) {
      return String(a.model).localeCompare(String(b.model)) ||
        String(a.productTitle).localeCompare(String(b.productTitle)) ||
        String(a.color).localeCompare(String(b.color));
    });
    var customerLabels = { child: "Child", woman: "Women's", man: "Men's" };
    var customer = customerLabels[answers.customer] || "Selected";
    var width = answers.width ? answers.width.charAt(0).toUpperCase() + answers.width.slice(1) : "";
    var html = '<div class="biopods-finder-results">';
    html += "<h3>In-stock footwear: " + escapeHtml(customer + " " + (answers.size || "") + " - " + width + " width.") + "</h3>";
    html += '<div class="biopods-finder-advice"><strong>Fit advice:</strong> For the best fit, measure your feet with the <a href="/pages/foot-measurement-instructions">Foot Measurement Guide</a>. For help, email <a href="mailto:orders@biopods.com">orders@biopods.com</a>.</div>';

    if (results.length) {
      html += '<div class="biopods-finder-card-grid biopods-finder-footwear-grid">';
      results.forEach(function (item) {
        var imageAlt = [item.productTitle, item.color, item.size].filter(Boolean).join(" — ");
        html += '<article class="biopods-finder-card biopods-finder-footwear-card">';
        if (item.image) {
          html += '<a class="biopods-finder-card-image" href="' + escapeHtml(item.url) + '">';
          html += '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(imageAlt) + '" loading="lazy" width="720" height="450">';
          html += "</a>";
        }
        html += '<div class="biopods-finder-card-content">';
        html += "<h4>" + escapeHtml(item.productTitle) + "</h4>";
        html += '<dl class="biopods-finder-variant-details">';
        html += "<div><dt>Model</dt><dd>" + escapeHtml(item.model) + "</dd></div>";
        if (item.color) html += "<div><dt>Color</dt><dd>" + escapeHtml(item.color) + "</dd></div>";
        html += "<div><dt>Size</dt><dd>" + escapeHtml(customer + " " + item.size) + "</dd></div>";
        html += "<div><dt>Width</dt><dd>" + escapeHtml(width) + "</dd></div>";
        html += "</dl>";
        html += '<p class="biopods-finder-price">';
        if (item.compareAtPrice) html += '<s>' + escapeHtml(item.compareAtPrice) + "</s> ";
        html += "<strong>" + escapeHtml(item.price) + "</strong></p>";
        html += '<div class="biopods-finder-card-actions">';
        html += '<button type="button" class="biopods-finder-add" data-biopods-add-variant="' + escapeHtml(item.variantId) + '">Add to Cart</button>';
        html += '<a class="biopods-finder-card-link" href="' + escapeHtml(item.url) + '">View Product</a>';
        html += "</div></div></article>";
      });
      html += "</div>";
    } else {
      html += '<div class="biopods-finder-empty"><strong>No in-stock variants match all three selections right now.</strong><br>Go back to choose another available width or size.</div>';
    }

    html += renderResultActions();
    html += "</div>";
    return html;
  }

  function addFootwearVariant(button) {
    if (!button || button.disabled) return;
    var variantId = button.getAttribute("data-biopods-add-variant");
    var originalText = button.textContent;
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    button.disabled = true;
    button.textContent = "Adding…";

    fetch(routesRoot + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) throw new Error(data.description || "This variant could not be added.");
        return data;
      });
    }).then(function (data) {
      button.textContent = "Added to Cart";
      button.classList.add("is-added");
      document.dispatchEvent(new CustomEvent("biopods:variant-added", {
        detail: { variantId: variantId, response: data }
      }));
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
        button.classList.remove("is-added");
      }, 1800);
    }).catch(function (error) {
      button.textContent = "Could not add — try again";
      button.title = error.message || "This variant could not be added.";
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 2600);
    });
  }

  function renderResultActions() {
    return '<div class="biopods-finder-actions">' +
      '<button type="button" class="biopods-finder-secondary" data-biopods-finder-back>Back</button>' +
      '<button type="button" class="biopods-finder-primary" data-biopods-finder-restart>Start again</button>' +
      "</div>";
  }

  function renderResults(type) {
    var body = modals[type].body;
    if (!body) return;
    setProgress(type, 100);
    body.innerHTML = type === "insoles" ? renderInsoleResults() : renderFootwearResults();
  }

  function finderTypeFromHref(href) {
    if (href === "#biopods-insole-finder" || href === "#biopods-insoles-finder" || href === "#quiz-Cx0I2e") return "insoles";
    if (href === "#biopods-footwear-finder" || href === "#biopods-shoe-finder" || href === "#quiz-3t5kKy") return "footwear";
    return "";
  }

  function handleHash() {
    var type = finderTypeFromHref(window.location.hash);
    if (type) openQuiz(type);
  }

  function init() {
    ["insoles", "footwear"].forEach(function (type) {
      var modal = document.querySelector('[data-biopods-finder-modal="' + type + '"]');
      if (!modal) return;
      modals[type] = {
        modal: modal,
        body: modal.querySelector("[data-biopods-finder-body]"),
        progress: modal.querySelector("[data-biopods-finder-progress]")
      };
    });

    if (!modals.insoles && !modals.footwear) return;
    insoleInventory = readInsoleInventory();
    footwearVariants = readFootwearVariants();

    document.addEventListener("click", function (event) {
      var openTrigger = event.target.closest("[data-biopods-quiz-open]");
      if (openTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openQuiz(openTrigger.getAttribute("data-biopods-quiz-open"));
        return;
      }

      var hashTrigger = event.target.closest("a[href]");
      var linkedType = hashTrigger ? finderTypeFromHref(hashTrigger.getAttribute("href")) : "";
      if (linkedType) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openQuiz(linkedType);
        return;
      }

      if (!activeType) return;

      if (event.target.closest("[data-biopods-finder-close]")) {
        event.preventDefault();
        closeQuiz();
        return;
      }

      var insoleAudienceButton = event.target.closest("[data-biopods-insole-audience]");
      if (insoleAudienceButton && activeType === "insoles") {
        event.preventDefault();
        state.insoles.answers.insole_size_audience = insoleAudienceButton.getAttribute("data-biopods-insole-audience");
        delete state.insoles.answers.insole_size;
        render("insoles");
        return;
      }

      var choice = event.target.closest("[data-biopods-finder-choice]");
      if (choice) {
        event.preventDefault();
        selectChoice(activeType, choice.getAttribute("data-biopods-finder-choice"));
        return;
      }

      var multi = event.target.closest("[data-biopods-finder-multi]");
      if (multi) {
        event.preventDefault();
        toggleMulti(activeType, multi.getAttribute("data-biopods-finder-multi"));
        return;
      }

      if (event.target.closest("[data-biopods-finder-continue]")) {
        event.preventDefault();
        var stepId = state[activeType].step;
        goTo(activeType, nextStep(activeType, stepId));
        return;
      }

      if (event.target.closest("[data-biopods-finder-back]")) {
        event.preventDefault();
        goBack(activeType);
        return;
      }

      if (event.target.closest("[data-biopods-finder-restart]")) {
        event.preventDefault();
        resetQuiz(activeType);
        render(activeType);
        return;
      }

      var addButton = event.target.closest("[data-biopods-add-variant]");
      if (addButton) {
        event.preventDefault();
        addFootwearVariant(addButton);
      }
    }, true);

    document.addEventListener("change", function (event) {
      var sizeSelect = event.target.closest("[data-biopods-insole-size]");
      if (!sizeSelect || activeType !== "insoles" || state.insoles.step !== "insole_size") return;

      state.insoles.answers.insole_size = sizeSelect.value;
      if (sizeSelect.value) goTo("insoles", "results");
    }, true);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && activeType) closeQuiz();
    });

    window.addEventListener("hashchange", handleHash);
    handleHash();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}());
